import SettingsForm from "./SettingsForm";
import FormLayout from "../../../components/Layout/FormLayout";

const SettingsFormContainer = ({ settingsData, submitFormHandler }) => {
  //   console.log("settingsData", settingsData, !!settingsData);
  const initialValues = {
    website_name: settingsData?.website_name || "",
    website_url: settingsData?.website_url || "",
    qrcode_url: settingsData?.qrcode_url || "",
    tag_line: settingsData?.tag_line || "",
    short_name: settingsData?.short_name || "",
    fav_image: settingsData?.fav_image || "",
    header_image: settingsData?.header_image || "",
    footer_image: settingsData?.footer_image || "",
    background_image: settingsData?.background_image || "",
    vat_type: settingsData?.vat_type || "",
    address: settingsData?.address || "",
    mobile: settingsData?.mobile || "",
    email: settingsData?.email || "",
    point: settingsData?.point || "",
    introducer_label: settingsData?.introducer_label || "",
    reg_prefix: settingsData?.reg_prefix || "",
    reg_no: settingsData?.reg_no || "",
    reg_expiry: settingsData?.reg_expiry || "",
    reg_type: settingsData?.reg_type || "",
    copyright: settingsData?.copyright || "",
    reset_reg_sequence: settingsData?.reset_reg_sequence || 1,
    starting_digit: settingsData?.starting_digit || "",
    year: settingsData?.year || "",
    month: settingsData?.month || "",
    days_of_week: settingsData?.days_of_week || "",
    logo_image: settingsData?.logo_image || "",
    package_in_medical_form: settingsData?.package_in_medical_form || "",
    reg_prefix_type: settingsData?.reg_prefix_type || "",
    agency_package_hide: settingsData?.agency_package_hide || 0,
    barcode_content: settingsData?.barcode_content || 0,
    next_prev_button: settingsData?.next_prev_button || 0,
    reg_img_fp_cn: settingsData?.reg_img_fp_cn || 0,
    collection_barcode_printing: settingsData?.collection_barcode_printing || 0,
    reg_submit_button: settingsData?.reg_submit_button || 0,
    printer_name_show: settingsData?.printer_name_show || 0,
    varification_show: settingsData?.varification_show || 0,
    gcc_code: settingsData?.gcc_code || "",
  };

  return (
    <FormLayout
      initialValues={initialValues}
      apiHandler={submitFormHandler}
      noButton={true}
      enableReinitialize={true}
    >
      <SettingsForm />
    </FormLayout>
  );
};

export default SettingsFormContainer;
